module.exports = __webpack_public_path__ + "static/k-store-8-5c836c804ed0fca1fe9eff6a02219e2b.jpg";